import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import InputBox from '@/components/profile/inputBox'
import CheckBox from '@/components/profile/checkBox'
import RoundBlueButton from '@/components/profile/roundBlueButton'

import '@/pages/profile/sections/common.css'

import "./style.css"

export default function LegalInfoView(props: any) {
    const { profile } = useLocalTranslation();

    return (
        <div
            className={`legalInfoViewMain
        rounded-[10px] profileSectionCommonMainCon`}>
            <h1 className='commonH1'>{profile.legalInformationSection.heading}</h1>
            <div className='profileSectionOfSectionCommonMainCon'>
                <div className='commonCon1'>
                    <p>
                        {profile.legalInformationSection.notes.n1}
                        <b>{profile.legalInformationSection.notes.n2}</b>
                        {profile.legalInformationSection.notes.n3}
                    </p>
                </div>


                {props.errMsg !== "" &&
                    <p className='commonErr1'>{props.errMsg}</p>
                }


                <div className='mb-[23px]'>
                    <InputBox
                        id="legalFirstName_id"
                        onChange={(e: any) => props.handleInputChange(e, "legalFirstName")}
                        value={props.legalFirstName}
                        placeholder={profile.placeHolders.legalFirstName}
                        showAsterisk={true}
                    />
                </div>

                <div className='mb-[23px]'>
                    <InputBox
                        id="legalMiddleName_id"
                        onChange={(e: any) => props.handleInputChange(e, "legalMiddleName")}
                        value={props.legalMiddleName}
                        placeholder={profile.placeHolders.legalMiddleName}
                    />
                </div>

                <div className='mb-[23px]'>
                    <InputBox
                        id="legalLastName_id"
                        onChange={(e: any) => props.handleInputChange(e, "legalLastName")}
                        value={props.legalLastName}
                        placeholder={profile.placeHolders.legalLastName}
                        showAsterisk={true}
                    />
                </div>

                <CheckBox
                    id="legalInfoAcknowledged_id"
                    text={profile.legalInformationSection.notes.n4}
                    checked={props.legalInfoAcknowledged}
                    onChange={(e: any) => props.handleOnCheckBoxChanged(e, "legalInfoAcknowledged")}
                    showAsterisk={true}
                />

                <div className='commonBtnCon1'>
                    <RoundBlueButton
                        disabled={props.isSubmitBtnLoading}
                        onClick={() => props.handleSubmit('legalInfo')}
                    />
                </div>
            </div>
        </div>
    );
}
